export default class PostFileCaption {
  constructor(rawData = {}) {
    this.id = rawData.id;
    this.creationDate = rawData.creationDate;
  }
}
